import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

const SidebarContainerLayout = lazyRouteComponent(() => import('@/_containers/layouts/sidebar-container'));

export const Route = createFileRoute('/_instructor')({
  component: SidebarContainerLayout,
});
